/*       */

import { gql } from '@apollo/client';
import { eventEntityRelationCommonFields } from 'graphql/entities/relationships/eventEntityRelationsQuery';

export default gql`
    mutation createEventEntityRelationMutation(
        $event: EventReferenceInput!
        $entity: EntityReferenceInput!
        $relationDefinition: ID!
        $attributes: JSON
    ) {
        payload: eventEntityRelationAdd(event: $event, entity: $entity, relationDefinition: $relationDefinition, attributes: $attributes) {
            ${eventEntityRelationCommonFields}
        }
    }
`;
